/**
 * Initialize tracking scripts (GTM, Hotjar, FullStory, Survicate)
 * This runs before the main app to ensure tracking is set up early
 */

// Hotjar. Previously hardcoded inline in index.html with no gate at all, so it
// recorded local development sessions into the same workspace as real traffic.
// `import.meta.env.PROD` is false only under the dev server — VITE_ENV cannot be
// used here because `npm run dev` runs with the staging env group, so it is
// indistinguishable from a deployed staging build. Deployed environments behave
// exactly as before; VITE_HOTJAR_ID can point an environment at its own property.
const HOTJAR_ID = import.meta.env.VITE_HOTJAR_ID || "1746352";

if (import.meta.env.PROD && HOTJAR_ID) {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: Number(HOTJAR_ID), hjsv: 6 };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
}

// Initialize Google Tag Manager
if (import.meta.env.VITE_GTM_ID) {
  // Update noscript iframe
  const noscriptIframe = document.querySelector("noscript iframe");
  if (noscriptIframe) {
    noscriptIframe.src =
      "https://www.googletagmanager.com/ns.html?id=" + import.meta.env.VITE_GTM_ID;
  }

  // Initialize GTM script
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", import.meta.env.VITE_GTM_ID);
}

// Initialize FullStory (only in production)
if (import.meta.env.VITE_ENV === "production") {
  window["_fs_debug"] = false;
  window["_fs_host"] = "fullstory.com";
  window["_fs_script"] = "edge.fullstory.com/s/fs.js";
  window["_fs_org"] = "10JJBT";
  window["_fs_namespace"] = "FS";
  (function (m, n, e, t, l, o, g, y) {
    if (e in m) {
      if (m.console && m.console.log) {
        m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
      }
      return;
    }
    g = m[e] = function (a, b, s) {
      g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
    };
    g.q = [];
    o = n.createElement(t);
    o.async = 1;
    o.crossOrigin = "anonymous";
    // eslint-disable-next-line no-undef
    o.src = "https://" + _fs_script;
    y = n.getElementsByTagName(t)[0];
    y.parentNode.insertBefore(o, y);
    g.identify = function (i, v, s) {
      g(l, { uid: i }, s);
      if (v) g(l, v, s);
    };
    g.setUserVars = function (v, s) {
      g(l, v, s);
    };
    g.event = function (i, v, s) {
      g("event", { n: i, p: v }, s);
    };
    g.anonymize = function () {
      g.identify(!!0);
    };
    g.shutdown = function () {
      g("rec", !1);
    };
    g.restart = function () {
      g("rec", !0);
    };
    g.log = function (a, b) {
      g("log", [a, b]);
    };
    g.consent = function (a) {
      g("consent", !arguments.length || a);
    };
    g.identifyAccount = function (i, v) {
      o = "account";
      v = v || {};
      v.acctId = i;
      g(o, v);
    };
    g.clearUserCookie = function () {};
    g.setVars = function (n, p) {
      g("setVars", [n, p]);
    };
    g._w = {};
    y = "XMLHttpRequest";
    g._w[y] = m[y];
    y = "fetch";
    g._w[y] = m[y];
    if (m[y])
      m[y] = function () {
        return g._w[y].apply(this, arguments);
      };
    g._v = "1.3.0";
  })(window, document, window["_fs_namespace"], "script", "user");
}

// Initialize Survicate
if (import.meta.env.VITE_SURVICATE_WORKSPACE_ID) {
  // Set attributes function
  (function (w) {
    function setAttributes() {
      var providerRouteRegex = /provider\/(.+)\/(.+)/;
      var clientPortalRouteResult = providerRouteRegex.exec(location.pathname);

      if (clientPortalRouteResult) {
        var requestId = clientPortalRouteResult[1];
        var providerId = clientPortalRouteResult[2];

        if (w._sva) {
          w._sva.setVisitorTraits({
            user_id: providerId,
            kaddim_request_id: requestId,
          });
        }
      }
    }
    if (w._sva) {
      setAttributes();
    } else {
      w.addEventListener("SurvicateReady", setAttributes);
    }
  })(window);

  // Load Survicate script
  (function () {
    var s = document.createElement("script");
    s.src =
      "https://survey.survicate.com/workspaces/" +
      import.meta.env.VITE_SURVICATE_WORKSPACE_ID +
      "/web_surveys.js";
    s.async = true;
    var e = document.getElementsByTagName("script")[0];
    e.parentNode.insertBefore(s, e);
  })(window);
}
